import React from 'react';
import '../styles/About.css';
import { motion } from 'framer-motion';

function About() {
  return (
    <section className="section about-section" id="about">
      <div className="section-title">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Sobre Nosotros
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Tu centro estético de confianza en Vallecas
        </motion.p>
      </div>
      
      <div className="about">
        <motion.div 
          className="about-text"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p><strong>Ari Lashes & Brow</strong> es un centro estético especializado en extensión de pestañas ubicado en Madrid. Este establecimiento es conocido por su dedicación a proporcionar a sus clientes los mejores servicios con grandes y espectaculares resultados.</p>
          <br />
          <p>Nuestro objetivo es realzar tu belleza natural, dándote una mirada más intensa y expresiva que te hará sentir segura y radiante todos los días.</p>
          
          <div className="about-stats">
            <div className="stat-item">
              <h4>+1000</h4>
              <p>Clientas Felices</p>
            </div>
            <div className="stat-item">
              <h4>5 Años</h4>
              <p>De Experiencia</p>
            </div>
          </div>
        </motion.div>
        
        <motion.div 
          className="about-image-wrapper"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="about-image glass-card">
            <img src="/images/interior.webp" alt="Interior de Ari Lashes" />
          </div>
          <div className="decoration-blob"></div>
        </motion.div>
      </div>
    </section>
  );
}

export default About;